import { memo } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LandingPage from "../1_KsbPages/LandingPage/LandingPage";
import EmailVerify from "../1_KsbPages/LandingPage/EmailVerify/EmailVerify";
import ProfilePage from "../1_KsbPages/ProfilePage/ProfilePage";
import Husibuech from "../../3_apps/5_Husibuech/Husibuech";
import ChatApp from "../../3_apps/6_ChatApp/ChatApp";
import GatterApp from "../../3_apps/7_GatterApp/GatterApp";
import EventManager from "../../3_apps/3_EventManagerApp/EventManager";
import SondertageApp from "../../3_apps/4_SondertageApp/SondertageApp";
import Dashboard from "../2_DashboardPage/Dashboard";
import VerifyInfo from "../1_KsbPages/LandingPage/EmailVerify/VerifyInfo";
import ResetPasswordPage from "../1_KsbPages/LandingPage/Login/ResetPasswordPage";
import NotFound from "../1_KsbPages/NotFound/NotFound";
import PrivateRoute from "./PrivateRoute";
import AdminPage from "../1_KsbPages/AdminPage/AdminPage";
import { useAppContext } from "../context/appContext";
import BSZFinderPage from "../../3_apps/1_BSZFinderApp/BSZFinderPage";
import BSZPlannerPage from "../../3_apps/2_BSZPlannerApp/BSZPlannerPage";
import AskomaPage from "../../3_apps/8_AskomaApp/AskomaPage";

function AppRoutes() {
  const { isAuthenticated, isAnAdmin } = useAppContext();
  return (
    <Routes>
      {/* Login */}
      <Route path={"/login"} element={<LandingPage />} />
      <Route
        path="/reset-password/:userId/:token"
        element={<ResetPasswordPage />}
      />
      <Route path={"/verify/:id/:code"} element={<EmailVerify />} />
      <Route path={"/test"} element={<EmailVerify />} />
      <Route path="/test2" element={<ResetPasswordPage />} />
      <Route path="/verify-info" element={<VerifyInfo />} />

      {/* Dashboard */}
      <Route path={"/"} element={<PrivateRoute />}>
        <Route path={"/"} element={<Dashboard />} />
      </Route>
      <Route path={""} element={<PrivateRoute />}>
        <Route path={""} element={<Navigate replace to="/" />} />
      </Route>
      <Route path={"/dashboard"} element={<PrivateRoute />}>
        <Route path={"/dashboard"} element={<Navigate replace to="/" />} />
      </Route>
      <Route path={"/profil"} element={<PrivateRoute />}>
        <Route path={"/profil"} element={<ProfilePage />} />
      </Route>
      <Route path={"/gatterApp"} element={<PrivateRoute />}>
        <Route path={"/gatterApp"} element={<GatterApp />} />
      </Route>
      <Route path={"/bszFinder"} element={<PrivateRoute />}>
        <Route path={"/bszFinder"} element={<BSZFinderPage />} />
      </Route>
      <Route path={"/bszPlanner"} element={<PrivateRoute />}>
        <Route path={"/bszPlanner"} element={<BSZPlannerPage />} />
      </Route>
      <Route path={"/chatApp"} element={<PrivateRoute />}>
        <Route path={"/chatApp"} element={<ChatApp />} />
      </Route>
      <Route path={"/sonderApp"} element={<PrivateRoute />}>
        <Route path={"/sonderApp"} element={<SondertageApp />} />
      </Route>
      <Route path={"/eventManagerApp"} element={<PrivateRoute />}>
        <Route path={"/eventManagerApp"} element={<EventManager />} />
      </Route>
      <Route path={"/husibuech"} element={<PrivateRoute />}>
        <Route path={"/husibuech"} element={<Husibuech />} />
      </Route>
      <Route path={"/askoma"} element={<PrivateRoute />}>
        <Route path={"/askoma"} element={<AskomaPage />} />
      </Route>
      {/* Everything else */}
      <Route path="*" element={<NotFound />} />

      {/* Settings (only Admins) */}
      <Route path={"/einstellungen"} element={<PrivateRoute />}>
        {isAuthenticated && isAnAdmin ? (
          <Route path={"/einstellungen"} element={<AdminPage />} />
        ) : (
          <Route
            path={"/einstellungen"}
            element={<Navigate replace to="*" />}
          />
        )}
      </Route>
    </Routes>
  );
}
export default memo(AppRoutes);
